// Mappers for company logo update operations
import type {
  LC_UpdateCompanyLogoIn,
  LC_UpdateCompanyLogoOut,
  UpdateCompanyLogoResult,
} from '../types/companyLogo.types';
import { extractBase64FromDataURL } from '@/utils/imageProcessing';

/**
 * Maps internal logo data to transport DTO for API request
 * @param _companyId - The company ID (not used, backend gets it from JWT)
 * @param logoDataUrl - The base64 data URL with prefix (data:image/jpeg;base64,...)
 * @returns Transport DTO ready for API
 */
export function mapToUpdateCompanyLogoIn(
  _companyId: number,
  logoDataUrl: string,
): LC_UpdateCompanyLogoIn {
  // Extract base64 without the data:image/...;base64, prefix
  const logoBase64 = extractBase64FromDataURL(logoDataUrl);

  return {
    image: {
      originalName: 'company-logo.jpg',
      extension: 'jpg',
      binary: logoBase64,
    },
  };
}

/**
 * Maps transport DTO response to internal result model
 * @param transportOut - The API response
 * @returns Internal result model
 */
export function mapUpdateCompanyLogoOutToResult(
  transportOut: LC_UpdateCompanyLogoOut,
): UpdateCompanyLogoResult {
  return {
    success: true,
    logoUrl: transportOut.url || undefined,
  };
}

/**
 * Creates an error result for failed logo update
 * @param error - Error message
 * @returns Error result
 */
export function createLogoUpdateErrorResult(error: string): UpdateCompanyLogoResult {
  return {
    success: false,
    error,
  };
}
